import { Link } from "react-router-dom";
import { buildPath } from "@/lib/routes";
import { useLang } from "@/hooks/useLang";
import Seo from "@/components/Seo";

export default function NotFound() {
  const { lang, t } = useLang();
  return (
    <>
      <Seo routeKey="home" lang={lang} title="404 | Magnus Løv Schmidt" description={t("not_found")} />
      <section className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
        <div className="font-heading text-8xl md:text-9xl font-black tracking-tighter text-primary/20">404</div>
        <h1 className="mt-4 font-heading text-3xl md:text-4xl font-extrabold tracking-tight">{t("not_found")}</h1>
        <Link to={buildPath("home", lang)} data-testid="notfound-home"
          className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary px-6 py-3.5 font-medium text-primary-foreground transition-transform hover:scale-[1.03]">
          {t("go_home")}
        </Link>
      </section>
    </>
  );
}
